import { useSelector } from 'react-redux'
import { useMemo, useEffect, useState } from 'react'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { generalConstants } from '@tweddle-se-team/common/constants'

const { BRANDS } = generalConstants
const { CUSTOMER_IDS } = customerHelper

const loadTMEFontVars = async ({ brand, shouldAlt }) => {
  if (brand === BRANDS.LEXUS) {
    const mod = await import('@/fonts/baseLexus')
    const arr = [mod.lexus.variable]
    if (shouldAlt) arr.push(mod.lexusAlternative.variable)
    return arr
  }

  if (brand === BRANDS.TOYOTA) {
    const mod = await import('@/fonts/baseToyota')
    return [mod.toyota.variable]
  }

  return []
}

const loadSubaruFontVars = async () => {
  const mod = await import('@/fonts/subaru')
  return [mod.subaru.variable, mod.subaruIcons.variable]
}

const loadNordicsFontVars = async () => {
  const mod = await import('@/fonts/subaruNordics')
  return [mod.subaruNordics.variable, mod.subaruIcons.variable]
}

const fontVarsLoaderByCustomer = {
  [CUSTOMER_IDS.TME]: loadTMEFontVars,
  [CUSTOMER_IDS.SUBARU]: loadSubaruFontVars,
  [CUSTOMER_IDS.NORDICS]: loadNordicsFontVars
}

export const useFontVarsLazy = ({ brand, customerId, shouldAlt }) => {
  const [vars, setVars] = useState([])

  useEffect(() => {
    let alive = true

    async function load() {
      const loadFontVars = fontVarsLoaderByCustomer[customerId] || loadTMEFontVars
      const nextVars = await loadFontVars({ brand, shouldAlt })
      if (alive) setVars(nextVars)
    }

    load()
    return () => {
      alive = false
    }
  }, [brand, customerId, shouldAlt])

  return vars
}

const localesWithAlternativeFont = ['az']

const useBrandClasses = () => {
  const brand = useSelector(state => state?.products?.filterBy?.brand?.toLowerCase() || BRANDS.TOYOTA)
  const customerId = useSelector(state => state?.configs?.customerId)
  const locale = useSelector(state => state?.i18nL10n?.locale)
  const customerClass = customerId?.toLowerCase()
  const isLexus = brand === BRANDS.LEXUS
  const shouldAlt = isLexus && localesWithAlternativeFont.includes(locale)

  const fontVars = useFontVarsLazy({ brand, customerId, shouldAlt })

  return useMemo(() => {
    const cls = [brand, customerClass]
    if (shouldAlt) cls.push('alternative')
    return [...cls, ...fontVars]
  }, [brand, customerClass, fontVars, shouldAlt])
}
export default useBrandClasses
